import React from 'react';
import { InfoIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IntroStory() {
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-205" data-mp="29hlmcbz494ah">
      <div className="mx-auto max-w-3xl" data-id="element-206" data-mp="29hbusjyfap2o">
        <SectionHeading title="From Disconnected Periodontal Knowledge to a Clearer Clinical Framework" data-id="element-207" data-mp="2egf3qfhixffx" />

        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/85 sm:text-lg" data-id="element-208" data-mp="20ge2gyxck5zx">
          <p data-id="element-209" data-mp="24i93s3fa2jdp">
            You already know about periodontal anatomy, gingival and periodontal conditions, clinical examination,
            periodontal classification, risk factors, treatment concepts, and maintenance.
          </p>
          <p className="font-serif text-2xl font-bold leading-snug text-brand-dark" data-id="element-210" data-mp="1vilxb37oynds">
            But knowing these subjects individually doesn’t always make it easy to connect them when you’re reviewing a
            periodontal case.
          </p>
          <p data-id="element-211" data-mp="2b9n8szn3wst">
            That’s exactly why I created <strong data-id="element-212" data-mp="2a803q5cnjuq">Perio Blueprint™</strong>.
          </p>
          <p data-id="element-213" data-mp="3thkgi2yert9l">
            I wanted to build a practical visual reference that helps you organize the information available, understand
            how the major periodontal concepts relate, identify what still needs to be evaluated, and structure your next
            questions.
          </p>
          <p data-id="element-214" data-mp="3fhruum1qo38h">
            My goal is simple: help you complete a{' '}
            <strong className="bg-gold/30 px-1" data-id="element-215" data-mp="3fi1k27eym6d4">structured initial periodontal case review in 15 minutes</strong> when
            the necessary information is available.
          </p>
        </div>

        <div className="mt-8 flex gap-3 rounded-2xl bg-brand-light p-5 text-sm leading-relaxed text-brand-dark" data-id="element-216" data-mp="3ojrbhd8ud5aw">
          <InfoIcon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" data-id="element-217" data-mp="3jlhhh5yusaqv" />
          <p data-id="element-218" data-mp="13qnw7xj1bkde">
            This 15-minute target refers to organizing an initial review. It is not a guarantee that a complete periodontal
            examination, diagnosis, or treatment plan can be completed in that time.
          </p>
        </div>

        <p className="mt-8 text-center font-serif text-xl font-bold italic text-ink sm:text-2xl" data-id="element-219" data-mp="1ekmz90majrj">
          I designed Perio Blueprint™ to help you organize your thinking—not replace your clinical judgment.
        </p>

        <div className="mt-10" data-id="element-220" data-mp="afr2pfvfzqjq">
          <CTAButton label="I Want a Clearer Periodontal Framework" data-id="element-221" data-mp="aept7fu2rc44" />
        </div>
      </div>
    </section>;
}